import queryString from 'query-string';
import { pickBy, isEqual } from 'lodash';
import { Location } from 'history';
import { Schema } from './parts/SearchForm';
import { RegularHealthCheckupReportsQueryVariables } from './query';

export interface SearchParams {
  _page?: string;
  limit?: string;
}

export const defaultSearchParams = {
  _page: '1'
} satisfies SearchParams;

export const getSearchParamsFromLocation = (location: Location): SearchParams => {
  return {
    ...defaultSearchParams,
    ...queryString.parse(location.search, { arrayFormat: 'bracket' })
  };
};

export const convertSearchParamsToQueryString = (params: SearchParams): string =>
  queryString.stringify(params, { arrayFormat: 'bracket' });

export const convertSearchParamsToForm = (params: SearchParams): Schema => {
  return {
    page: params._page || '1',
    limit: params.limit || '100'
  };
};

export const convertFormToSearchParams = (form: Schema): SearchParams => {
  return pickBy({
    _page: form.page,
    limit: undefined // limitはSearchParamsに含めない
  });
};

export const convertSearchParamsToGraphQL = (params: SearchParams): RegularHealthCheckupReportsQueryVariables => {
  return {
    page: Number(params._page) || 1,
    limit: Number(params.limit) || 100
  };
};

export const hasConditions = (form: Schema): boolean => {
  return !isEqual(
    pickBy(convertFormToSearchParams(form), v => (Array.isArray(v) ? v.length > 0 : v)),
    defaultSearchParams
  );
};
